module.exports = __webpack_public_path__ + "img/top-qiwei-code.9efc88f.png";